import {
    origineGeographiqueVille,
    seoTopPages,
    topMotsCles,
} from '../../../modules/products/statistiques/ts'
import {Period} from './ReportProvider'
import {createContext} from 'react'
import {FullWPData, initialFullWPData} from '../../wp/types'

export interface PropsPersonalInformation {
    firstName: string,
    lastName: string,
    email: string,
}

export interface InterfaceContext {
    period: Period;
    conversion: number;
    seo: {
        nombrePagesVues: number;
        nombreVisites: number;
        mostViewedPage: seoTopPages[];
        geographicOriginByCity: origineGeographiqueVille[];
        byChannels: topMotsCles[]
    };
    callReceived: {
        has_cleverPhone: boolean;
        generalAppelRecu: number;
        click_sur_tel: number;
    }
    formsReceived: number;
    campagne: {
        countMessages: number;
        countDataContacts: number;
    },
    loadingStatus: 'idle' | 'pending' | 'fulfilled' | 'rejected',
    administration: {
        data: AdministrationData,
        loading: boolean
    },
    domainName: string
    wpData: FullWPData
}

export const initialState: InterfaceContext = {
    period: {
        start: '', end: '',
    },
    conversion: 0,
    seo: {
        nombrePagesVues: 0,
        nombreVisites: 0,
        mostViewedPage: [],
        geographicOriginByCity: [],
        byChannels: [],
    },
    callReceived: {
        has_cleverPhone: false,
        generalAppelRecu: 0,
        click_sur_tel: 0,
    },
    formsReceived: 0,
    campagne: {
        countMessages: 0,
        countDataContacts: 0,
    },
    loadingStatus: 'idle',
    administration: {
        data: {
            partage_media_1: {
                title: '',
                sub_title: '',
                text: '',
                icon: null,
                image: '',
                button: {
                    title: '',
                    href: '',
                },
            },
            partage_media_2: {
                title: '',
                sub_title: '',
                text: '',
                icon: null,
                image: null,
                button: {
                    title: '',
                    href: '',
                },
            },
            position_6: {
                title: '',
                sub_title: '',
                text: '',
                icon: '',
                image: null,
                button: {
                    title: '',
                    href: '',
                },
            },
            position_header: {
                title: '',
                sub_title: '',
                text: '',
                icon: '',
                image: null,
                button: null,
            },
            position_top_5: {
                title: '',
                sub_title: '',
                text: '',
                icon: '',
                image: null,
                button: null,
            },
            pub_meddle: {
                title: '',
                sub_title: '',
                text: '',
                icon: '',
                image: null,
                button: {
                    title: '',
                    href: '',
                },
            },
        },
        loading: true,
    },
    wpData: initialFullWPData,
    domainName: ''
}

export const ReportContext = createContext<InterfaceContext>(initialState)

export interface Button {
    title: string;
    href: string;
}

export interface Position {
    button: Button | null;
    icon: string | null;
    image: string | null;
    sub_title: string;
    text: string;
    title: string;
}

export interface AdministrationData {
    partage_media_1: Position;
    partage_media_2: Position;
    position_6: Position;
    position_header: Position;
    position_top_5: Position;
    pub_meddle: Position;
}
